module.exports = __webpack_public_path__ + "static/media/pilates.b97053e3.svg";